import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getProductReviews = async (productId: number | string) => {
  let query = supabase
    .from('product_reviews')
    .select(
      `
      *,
      user:user_profiles(username, avatar)
    `,
    );

  // Only apply product filter if productId is not '*' (which means get all reviews)
  if (productId !== '*') {
    query = query.eq('product', productId);
  }

  const { data, error } = await query.order('created_at', { ascending: false });

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export default function useGetProductReviewsByProductId(productId: number | string) {
  return useQuery({
    queryKey: ['useGetProductReviewsByProductId', productId],
    queryFn: () => getProductReviews(productId),
    staleTime: 0,
    enabled: !!productId,
  });
}
